module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_40.1293fa56.mp3";